import { HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { AddOnDetail } from 'src/app/classes/add-on-detail';
import { CreateAddOnPayload } from 'src/app/classes/create-addon-payload';
import { DriverTask } from 'src/app/classes/driver-task';
import { DropOffTask } from 'src/app/classes/dropoff-task';
import { EndDeleteTaskPayload } from 'src/app/classes/end-delete-task';
import { Events } from 'src/app/classes/events';
import { Passenger } from 'src/app/classes/passenger';
import { PickUpTask } from 'src/app/classes/pickup-task';
import { RemoteParkingMyTasks } from 'src/app/classes/remote-parking';
import { RemoveAddOnPayload } from 'src/app/classes/remove-addon-payload';
import { DispatchService } from 'src/app/services/dispatch.service';
import { EventsDeltaService } from 'src/app/services/events-delta.service';
import { EventsService } from 'src/app/services/events.service';
import { LoggerService } from 'src/app/services/logger.service';
import { MyTasksService } from 'src/app/services/my-tasks.service';
import { ProfileService } from 'src/app/services/profile.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ConfirmPassengerNotCheckedInDialogComponent } from '../confirm-passenger-not-checked-in-dialog/confirm-passenger-not-checked-in-dialog.component';
import { EndTaskReasonDialogComponent } from './end-task-reason-dialog/end-task-reason-dialog.component';
import { MyTaskConfirmationDialogComponent } from './my-task-confirmation-dialog/my-task-confirmation-dialog.component';

const enum TaskActionType {
  PICKUP = 'pickup',
  DROPOFF = 'dropoff'
}
export enum PickUpDropOffType {
  PICKUP_ALL = 'pickupAll',
  PICKUP_SELECTED = 'pickupSelected',
  DROPOFF_ALL = 'dropoffAll',
  DROPOFF_SELECTED = 'dropoffSelected'
}

export interface AddOnFormDetail{
  type: string,
  value: string,
  isActive: boolean
}
@Component({
  standalone: false,
  selector: 'app-my-tasks',
  templateUrl: './my-tasks.component.html',
  styleUrls: [ './my-tasks.component.scss' ]
})
export class MyTasksComponent implements OnInit {
  PickUpDropOffType = PickUpDropOffType;
  driverTasksForm: FormGroup;
  events: Events;
  driverTasks: Array<DriverTask>;
  unsubscribe$: Subject<boolean> = new Subject();
  noDriverTasks = true;
  showAdd: boolean;
  expandedPanel = '-1';
  addItemTypes: any[];
  pickupAllPayload: any;
  warningIcon = faExclamationTriangle as IconProp;
  flightCustoms: Array<string>;
  currentTaskToProcess = '';
  loading = true;
  pickUpDropOffAll = false;
  partialPassengerDropoff = false;
  partialAddOnDropoff = false;

  constructor(
    public fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private dispatchService: DispatchService,
    private eventsService: EventsService,
    private eventsDeltaService: EventsDeltaService,
    private utilsService: UtilitiesService,
    public dialog: MatDialog,
    private logger: LoggerService,
    private myTasksService: MyTasksService,
    private toastService: ToastService,
    private profileService: ProfileService,
    private utilityService: UtilitiesService
  ) {}

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.buildForm();
    this.addItemTypes = [
      { name: 'Passenger', value: 'Passenger' },
      { name: 'Paperwork', value: 'Paperwork' },
      { name: 'Catering', value: 'Catering' },
      { name: 'Other', value: 'Other' }
    ];
    this.subscribeToEvents();
    this.subscribeToEventDeltas();
   }

  buildForm(): void {
    this.driverTasksForm = this.fb.group({
      cordNotes: this.fb.control(''),
      driverNotes: this.fb.control(''),
      taskDetails: this.fb.group({}),
      passengers: this.fb.group({})
    });
  }

  setExpandedpanel(data: DriverTask): void {
    this.expandedPanel = data.taskName;
    this.driverTasksForm.get('cordNotes').setValue(data.specialInstructions);
    this.driverTasksForm.get('driverNotes').setValue(data.driverNotes === 'null' ? '' : data.driverNotes);
  }

  toggleAddItem(status: boolean): void {
    if (status === false) {
      this.dialog.open(MyTaskConfirmationDialogComponent,{
        width: '550px',
        data: {
          message: 'Are you sure you want to delete this item?'
        }
      }).afterClosed().subscribe(response => {
        if (response) {
          this.showAdd = status;
        }
      });
    } else {
      this.showAdd = status;
    }
  }

  get taskDetails(): FormGroup {
    return this.driverTasksForm.get('taskDetails') as FormGroup;
  }



  newValueTaskDetails(type: string, value: string): FormGroup {
    return this.fb.group({
      type: type,
      value: value,
      isActive: false
    });
  }

  areAnyPassengersChecked(): boolean {
    const form = this.driverTasksForm.value;
    const formPassengers = form.passengers;
    for (const [key, value] of Object.entries(formPassengers)) {
      const isChecked = value;
      if(isChecked){
        // console.log("passengers checked!!");
        return true;
      }
    }
    return false;
  }

  checkTheLastAddOn(): void {
    let len = 0;
    Object.keys(this.taskDetails['controls']).forEach((key, i) => {
      len++;
    });

      Object.keys(this.taskDetails['controls']).forEach((key, i) => {
        // console.log(this.taskDetails['controls'][key]['controls']['isActive']);

            if (i === len - 1) {
              this.taskDetails['controls'][key]['controls']['isActive'].setValue(true);
              this.taskDetails['controls'][key].disable();
            }
      });
  }

  populateAndAddTaskDetails(taskName: string, type: string, value: string, e: any): void {
    if(type === undefined){
      this.toastService.show(`Form Error: Please select the type of add-on`, { classname: 'bg-danger text-light', delay: 4000 });
      return;
    }

   const passChecked = this.areAnyPassengersChecked();

   const detailsId: string = this.utilsService.guid();
   const payload: CreateAddOnPayload = {
     type: 'createAddOn',
     updatedBy: this.profileService.profileObs$.getValue().adId,
     newAddOn: {
       id: detailsId,
       type: type,
       name: value
     }
   }
    this.myTasksService.createAddOn(payload, taskName)
    .pipe(tap(() => this.eventsDeltaService.getDeltas()))
    .subscribe((resp:HttpResponse<any>) => {
      this.logger.debug(`PUT createAddOn response:`, resp, 'http');
       if(resp.status === 204){
        // add the new slider control to the form
        this.taskDetails.addControl(
          this.getDriverPassengerFormKey(taskName, detailsId),
          this.newValueTaskDetails(type, value)
        );

        this.driverTasks.forEach((driverTask: DriverTask) => {
          if (driverTask.taskName === taskName) {
            driverTask.addOnDetails = driverTask.addOnDetails || [];
            driverTask.addOnDetails.push({ id: detailsId, type, name: value });
          }
        });
        this.showAdd = false;
        if(passChecked){
          this.checkTheLastAddOn();
        }
        e.stopImmediatePropagation();
        this.toastService.show(`Success: Task Updated`, { classname: 'bg-success text-light', delay: 4000 });
      }else{
        this.toastService.show(`Error: ${resp.status} occurred, task was not updated!`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });
  }

  onRemoveTaskDetails(taskName: string, detailId: number | string): void {
    this.dialog.open(MyTaskConfirmationDialogComponent,{
      width: '550px',
      data: {
        message: 'Are you sure you want to delete this item?'
      }
    }).afterClosed().subscribe(response => {
      if (response) {
        this.removeTaskDetails(taskName, detailId);
      }
    });
  }

  removeTaskDetails(taskName: string, detailId: number | string): void {
    const payload: RemoveAddOnPayload = {
      type: 'deleteAddOn',
      deleteAddOnId: detailId,
      deleteBy: this.profileService.profileObs$.getValue().adId
    }
    this.myTasksService.removeAddOn(payload, taskName)
    .pipe(tap(() => this.eventsDeltaService.getDeltas()))
    .subscribe((resp:HttpResponse<any>) => {
      this.logger.debug(`PUT removeAddOn response:`, resp, 'http');
       if(resp.status === 204){
        // remove the control to the form
        this.driverTasks.forEach((driverTask: DriverTask) => {
          if (driverTask.taskName === taskName) {
            driverTask.addOnDetails = driverTask.addOnDetails.filter((details: AddOnDetail) => details.id !== detailId);
          }
        });
        this.taskDetails.removeControl(this.getDriverPassengerFormKey(taskName, detailId));
        this.toastService.show(`Success: Task Updated`, { classname: 'bg-success text-light', delay: 4000 });
      }else{
        this.toastService.show(`Error: ${resp.status} occurred, task was not updated!`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });
  }

  getdueTime(date: string): any {
    return this.utilsService.timeMath(date);
  }

  updateDriverTaskForm(driverTasks: DriverTask[]): void {
    // Updates the passengers form group by adding/removing controls as the list of passengers are updated

    // Constructs a list of form control keys that are in the format `${driverTask.taskName}:${passenger.id}`
    const passengerKeys: string[] = [];
    driverTasks.forEach((driverTask: DriverTask) => {
      if (driverTask.passengers) {
        driverTask.passengers.forEach((passenger: Passenger) => {

          passengerKeys.push(this.getDriverPassengerFormKey(driverTask.taskName, passenger.id))
        }
        );
      }
    });

  //  console.log(passengerKeys);

    // Adds new form controls for passengers that didn't exist before
    passengerKeys.forEach((passengerKey: string) => {
      if (!(this.driverTasksForm.controls['passengers'] as FormGroup).contains(passengerKey)) {
        (this.driverTasksForm.controls['passengers'] as FormGroup).addControl(passengerKey, this.fb.control(false));
      }
    });

   // console.log(this.driverTasksForm.controls['passengers'] as FormGroup);



    // Removes any form controls for passengers that are no longer in the driverTasks
    Object.keys(this.driverTasksForm.controls['passengers'] as FormGroup).forEach((formKey: any) => {

      if(formKey === 'value'){
        const values = this.driverTasksForm.controls['passengers'][formKey];
        Object.keys(values).forEach(key => {
          if (!passengerKeys.includes(key)) {
           // console.log("MATCH FOUND!");
            // try{
            //   (this.driverTasksForm.controls['passengers'] as FormGroup).removeControl(key);
            //   console.log(`REMOVED: ${key}`);
            // }catch(e){
            //   console.log("...")
            // }
          }
        });
      }

      // if (!passengerKeys.includes(formKey)) {
      //   (this.driverTasksForm.controls['passengers'] as FormGroup).removeControl(formKey);
      // }
    });
  }

  updateDriverTaskFormAddOns(driverTasks: DriverTask[]): void {
    const addOnKeys: string[] = [];
    driverTasks.forEach((driverTask: DriverTask) => {
      if (driverTask.addOnDetails) {
        driverTask.addOnDetails.forEach((addOnDetails: AddOnDetail) => {

          addOnKeys.push(this.getDriverPassengerFormKey(driverTask.taskName, addOnDetails.id))
        }
        );

        driverTask.addOnDetails.forEach((details: AddOnDetail) => {
          const addOnKey = this.getDriverPassengerFormKey(driverTask.taskName, details.id);

          if (!(this.driverTasksForm.controls['taskDetails'] as FormGroup).contains(addOnKey)) {
            const fg: FormGroup = this.newValueTaskDetails(details.type, details.name);

            (this.driverTasksForm.controls['taskDetails'] as FormGroup).addControl(addOnKey, fg);
          }
        });

        Object.keys(this.driverTasksForm.controls['taskDetails']).forEach((formKey: string) => {
          if (!addOnKeys.includes(formKey)) {
            (this.driverTasksForm.controls['taskDetails'] as FormGroup).removeControl(formKey);
          }
        });
      }
    });
  }

  subscribeToEvents(): void {
    this.eventsService.getEventData().pipe(takeUntil(this.unsubscribe$)).subscribe((events) => {
      if (events) {
        this.events = events;
        this.driverTasks = events['driverTasks'];
        this.updateDriverTaskForm(this.driverTasks);
        this.updateDriverTaskFormAddOns(this.driverTasks);
        this.flightCustoms = this.events.uiParameters.FLIGHT_CUSTOMS;
        if (this.driverTasks && this.driverTasks.length > 50) {
          this.driverTasks = this.driverTasks.slice(0, 50);
        }
        this.noDriverTasks = !(this.driverTasks && this.driverTasks.length > 0);
      }
      this.loading = false;
    });
  }


  subscribeToEventDeltas(): void {
    this.eventsDeltaService.getEventData().pipe(takeUntil(this.unsubscribe$)).subscribe((events) => {
      if (events) {
        this.events = events;
        const driverTaskStatus = events['driverTaskStatus'];
        switch (driverTaskStatus) {
          case 'none':
            this.driverTasks = [];
            this.noDriverTasks = true;
            break;
          case 'updated':
            this.driverTasks = events['driverTasks'];
             if (this.driverTasks && this.driverTasks.length > 50) {
              this.driverTasks = this.driverTasks.slice(0, 50);
            }
            if (this.driverTasks && this.driverTasks.length > 0) {
              this.updateDriverTaskForm(this.driverTasks);
              this.updateDriverTaskFormAddOns(this.driverTasks);
            }
            this.noDriverTasks = !(this.driverTasks && this.driverTasks.length > 0);
            break;
          default:
            break;
        }
      }
      this.currentTaskToProcess = '';
      this.pickUpDropOffAll = false;
      this.loading = false;
    });
  }

  getDriverPassengerFormKey(driverTaskName: string, passengerId: number | string): string {
    return `${driverTaskName}:${passengerId}`;
  }

  getPassengerFormControl(driverTaskName: string, passengerId: number | string, status: string): FormControl {
    return (this.driverTasksForm.controls['passengers'] as FormGroup).controls[
      this.getDriverPassengerFormKey(driverTaskName, passengerId)
    ] as FormControl;
  }

  getDetailsFormControl(driverTaskName: string, status:string, detailsId: number | string): FormControl {
    return (this.driverTasksForm.controls['taskDetails'] as FormGroup).controls[
      this.getDriverPassengerFormKey(driverTaskName, detailsId)].get('isActive') as FormControl;
  }


  pickup(driverTask: DriverTask, allOrSelected: PickUpDropOffType.PICKUP_ALL | PickUpDropOffType.PICKUP_SELECTED): void {
    this.pickUpDropOffAll = allOrSelected === PickUpDropOffType.PICKUP_ALL ? true : false;
    this.currentTaskToProcess = driverTask.taskName;
    const form = this.driverTasksForm.value;
    // are there passengers that are not checked in?
    if (driverTask.passengers && driverTask.passengers.length && driverTask.passengers.some((e) => e.checkedIn === false)) {
      const dialogRef = this.dialog.open(ConfirmPassengerNotCheckedInDialogComponent, {
        width: '350px',
        data: {driverTask: driverTask},
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result){ // user clicked continue in modal
          this.markTaskAsStarted(driverTask, form, allOrSelected);
        }else{
          this.currentTaskToProcess = '';
          this.pickUpDropOffAll = false;
          this.loading = false;
        }
      });
     }else{
      this.markTaskAsStarted(driverTask, form, allOrSelected);
     }
  }

  markTaskAsStarted(driverTask: DriverTask, form: any, allOrSelected:  PickUpDropOffType.PICKUP_ALL | PickUpDropOffType.PICKUP_SELECTED){

    const payload: PickUpTask = {
      taskIds: [driverTask.taskName],
      assignTo: this.profileService.profileObs$.getValue().adId,
      passengers: this.extractPassengersFromForm(form, allOrSelected, driverTask.taskName),
      type: TaskActionType.PICKUP,
      driverNotes: form.driverNotes,
      addOnDetails: this.extractAddOnsFromForm(allOrSelected, driverTask)
    }
    this.myTasksService.markTaskAsStarted(payload)
    .pipe(tap(() => this.eventsDeltaService.getDeltas()))
    .subscribe((resp:HttpResponse<any>) => {
      this.logger.debug(`PUT markTaskAsStarted response:`, resp, 'http');
       if(resp.status === 200){
        // console.log(resp.body);
        this.toastService.show(`Success: Task Updated`, { classname: 'bg-success text-light', delay: 4000 });
      }else{
        this.toastService.show(`Error: ${resp.status} occurred, task was not updated!`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });
  }


  dropoff(driverTask: DriverTask, allOrSelected: PickUpDropOffType.DROPOFF_ALL | PickUpDropOffType.DROPOFF_SELECTED) {
    this.pickUpDropOffAll = allOrSelected === PickUpDropOffType.DROPOFF_ALL ? true : false;
    this.currentTaskToProcess = driverTask.taskName;
    const form = this.driverTasksForm.value;
    const payload: DropOffTask = {
      taskIds: [driverTask.taskName],
      assignTo: this.profileService.profileObs$.getValue().adId,
      passengers: this.extractPassengersFromForm(form, allOrSelected, driverTask.taskName),
      type: TaskActionType.DROPOFF,
      driverNotes: form.driverNotes,
      addOnDetails: this.extractAddOnsFromForm(allOrSelected, driverTask)
    }

    if (allOrSelected === PickUpDropOffType.DROPOFF_SELECTED && !form.driverNotes) {
      if (this.partialPassengerDropoff){
        this.toastService.show(`Error: A note is required when not dropping off all passengers.`, { classname: 'bg-danger text-light', delay: 4000 });
        this.currentTaskToProcess = '';
        return;
      } else if(this.partialAddOnDropoff){
        this.toastService.show(`Error: A note is required when not dropping off all add-ons.`, { classname: 'bg-danger text-light', delay: 4000 });
        this.currentTaskToProcess = '';
        return;
      }
    }

    this.myTasksService.dropoffPassengers(payload)
    .pipe(tap(() => {
      this.eventsService.triggerEventsUpdate();
      this.dispatchService.triggerDispatchUpdate();
    }))
    .subscribe((resp:HttpResponse<any>) => {
      this.logger.debug(`PUT dropoffPassengers response:`, resp, 'http');
      if(resp.status === 204){
        this.toastService.show(`Success: Task Updated`, { classname: 'bg-success text-light', delay: 4000 });
      }else{
        this.toastService.show(`Error: ${resp.status} occurred, task was not updated!`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });
  }



  extractPassengersFromForm(form: any, allOrSelected: string, taskName: string): string[]{
    let totalPassengers = 0;
    const passengers = [];
    const formPassengers = form.passengers;
    for (const [key, value] of Object.entries(formPassengers)) {
      const taskId = key.split(':')[0];
      if(taskId === taskName){
        totalPassengers++;
        const isChecked = value;
        const passengerId = key.slice(key.indexOf(":") + 1);
        if(allOrSelected === PickUpDropOffType.PICKUP_SELECTED || allOrSelected === PickUpDropOffType.DROPOFF_SELECTED){
          if(isChecked){
            passengers.push(passengerId);
          }
        }else{
          passengers.push(passengerId);
        }
        this.logger.debug(`isChecked: ${isChecked}, passengerId: ${passengerId}`, 'ui');
      }
    }
    if(allOrSelected === PickUpDropOffType.DROPOFF_SELECTED && passengers.length < totalPassengers){
      this.partialPassengerDropoff = true;
    }else{
      this.partialPassengerDropoff = false;
    }
    return passengers;
  }

  extractAddOnsFromForm(allOrSelected: string, driverTask: DriverTask): AddOnDetail[]{
    let totalAddOns = 0;
    const addOns = [];
    Object.keys(this.taskDetails['controls']).forEach((key, i) => {
      const addOnTaskId = key.split(':')[0];
      if(addOnTaskId === driverTask.taskName){
        totalAddOns++;
        const addOnId = key.slice(key.indexOf(":") + 1);
        const isChecked = this.taskDetails['controls'][key]['controls'].isActive.value;
         const obj: AddOnDetail = {
          type: this.taskDetails['controls'][key]['controls'].type.value,
          id: addOnId,
          name: this.taskDetails['controls'][key]['controls'].value.value
        }
        if(allOrSelected === PickUpDropOffType.PICKUP_SELECTED || allOrSelected === PickUpDropOffType.DROPOFF_SELECTED){
          if(isChecked){
            addOns.push(obj);
          }
        }else{
          addOns.push(obj);
        }
      }
    });
    if(allOrSelected === PickUpDropOffType.DROPOFF_SELECTED && addOns.length < totalAddOns){
      this.partialAddOnDropoff = true;
    }else{
      this.partialAddOnDropoff = false;
    }
    return addOns;
  }


  passengerOnChange(e: any, person: Passenger) {
    // console.log(e);
    // console.log(person.id);
    console.log(
      'DRIVER TASK FORM SHOULD BE UPDATED HERE WITH PICKUP STATUS FORM CONTROLS',
      this.driverTasksForm.get('passengers').value
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  getStatusColor(taskGroupStatus): string{
    return this.utilityService.getStatusColor(taskGroupStatus);
  }

  checkCustoms(origin): boolean{
    return this.flightCustoms.includes(origin);
  }

  canEndTaskWithoutReason(task: any):boolean{
    return ((task.plannedEnd === null || task.plannedEnd === '') && this.canEndTask(task)) || task.typeName === 'Terminal' ? true : false;
  }

  canDeleteTask(task: any):boolean{
    return (this.profileService.profileObs$.getValue().adId.toUpperCase() === task.createdBy.toUpperCase()) && (task.actualStart === null || task.actualStart === '') ? true : false;
  }

  canUnassignTask(task: any):boolean{
    return task.actualStart === null || task.actualStart === '' ? true : false;
  }

  canEndTask(task: any): boolean{
     return (this.profileService.profileObs$.getValue().adId.toUpperCase() === task.createdBy.toUpperCase()) && (task.actualStart !== null && task.actualStart !== '') ? true: false;
  }

  showPickUpButtons(status): boolean{
    return status !== 'Started'
  }

  showDropOffButtons(status): boolean{
    return status === 'Started'
  }

  // deleteTask(task: RemoteParkingMyTasks): void{
  //   this.endOrDeleteTaskNow(task.taskName, 'deleteTask');
  // }

  onEndTask(taskData: RemoteParkingMyTasks): void {
    this.dialog.open(MyTaskConfirmationDialogComponent, {
      width: '550px',
      data: {
        message: 'Are you sure?'
      }
    }).afterClosed().subscribe(response => {
      if (response) {
        this.endTask(taskData);
      }
    });
  }

  onEndOrDeleteTaskNow(taskName: string, type: string): void {
    this.dialog.open(MyTaskConfirmationDialogComponent, {
      width: '550px',
      data: {
        message: 'Are you sure?'
      }
    }).afterClosed().subscribe(response => {
      if (response) {
        this.endOrDeleteTaskNow(taskName, type);
      }
    });
  }

  endTask(task: RemoteParkingMyTasks): void{
    this.currentTaskToProcess = task.taskName;
    if(!this.canEndTaskWithoutReason(task)){
      this.openEndTaskReasonModal(task);
    }else{
      this.endOrDeleteTaskNow(task.taskName, 'endTask');
    }
  }

  private endOrDeleteTaskNow(taskName: string, type: string){
    this.currentTaskToProcess = taskName;
    const t = type === 'endTask' ? 'Ended' : 'Deleted';
    const payload: EndDeleteTaskPayload = {
      deleteBy: this.profileService.profileObs$.getValue().adId,
      driverNote: 'user performed action',
      taskId: taskName,
      timeStamp: moment().toISOString(),
      type: type
    };
    this.myTasksService.endOrDeleteTask(payload)
    .pipe(tap(() => this.eventsDeltaService.getDeltas()))
    .subscribe((resp:HttpResponse<any>) => {
      this.logger.debug(`PUT ${type} response:`, resp, 'http');
       if(resp.status === 204){
        this.toastService.show(`Success: The task was ${t}`, { classname: 'bg-success text-light', delay: 4000 });
      }else{
        this.toastService.show(`Error ${resp.status} occurred processing task`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });
  }

  openEndTaskReasonModal(driverTask: DriverTask | RemoteParkingMyTasks): void {
    const dialogRef = this.dialog.open(EndTaskReasonDialogComponent, {
      width: '350px',
      data: {driverTask: driverTask},
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.logger.debug(`Dialog result: ${result}`, 'ui');
      this.currentTaskToProcess = '';
    });
  }


  departASCEdgewood(taskName: string, type: 'depart-edgewood' | 'depart-asc'){
    this.currentTaskToProcess = taskName;
    const payload = {
      taskIds: [taskName],
      assignTo: this.profileService.profileObs$.getValue().adId,
      type: type
    }
    this.myTasksService.remoteParking(payload)
    .pipe(tap(() => this.eventsDeltaService.getDeltas()))
    .subscribe((resp:HttpResponse<any>) => {
      this.logger.debug(`PUT departASCEdgewood response:`, resp, 'http');
       if(resp.status === 204){
        this.toastService.show(`Success`, { classname: 'bg-success text-light', delay: 4000 });
      }else{
        this.toastService.show(`Error ${resp.status} occurred`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });

  }

  updateTasks(): void {
    this.loading = true;
    this.eventsDeltaService.getDeltas();
  }

  onUnassignTask(taskName: string) {
    this.dialog.open(MyTaskConfirmationDialogComponent, {
      width: '350px',
      data: {
        message: 'Are you sure?'
      }
    }).afterClosed().subscribe(response => {
      if (response) {
        this.unassignTask(taskName);
      }
    });
  }

  private unassignTask(taskName: string): void {
    this.currentTaskToProcess = taskName;
    const payload = {
      taskIds: [taskName],
      assignTo: this.profileService.profileObs$.getValue().adId,
      type: 'unassign'
    }
    this.myTasksService.unassignTask(payload)
    .pipe(tap(() => this.eventsDeltaService.getDeltas()))
    .subscribe((resp:HttpResponse<any>) => {
      this.logger.debug(`PUT unassign task response:`, resp, 'http');
       if(resp.status === 204){
        this.toastService.show(`Success: Task Unassigned`, { classname: 'bg-success text-light', delay: 4000 });
      }else{
        this.toastService.show(`Error: ${resp.status} occurred`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });
  }

  getIcon(type: string): string{
    switch (type) {
      case "Other":
        return 'icon-tasks-switch';
      case "Catering":
        return 'icon-cutlery-switch';
      case "Customs":
      case "Paperwork":
        return 'icon-file-switch';
      case "JS":
      case "FO":
      case "CPT":
      case "Passenger":
        return 'icon-user-switch';
      default:
        return 'icon-tasks-switch';
    }
  }



}
